<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          | 当前点位ID
        </div>
        <div class="label-dialog__seletce">
        <el-input v-model="nowpano_id"
                  maxlength="10"
                  class="mng-editor-panel__input"
                  style="width:150px"
                  placeholder="请输入点位ID" />
        <div class="ai-button ai-button--primary mng-editor-panel__button"
           style="width:100px; margin: 0px;margin-left:30px" @click="jumpPano">
        跳转
         </div>
        </div>
        <div class="ai-button ai-button--primary mng-editor-panel__button"
           @click="jumpPano">
        刷新数据
         </div>
      </div>
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="editor-panel-list">
          <div class="editor-panel-list__title">
            <span>视频名字</span>
            <span>全景状态</span>
            <span>畸变状态</span>
            <span>操作</span>
          </div>
          <div ref="listcontainer" class="editor-panel-list__items">
            <div v-for="(item, index) in videolist" :key="index"
              class="editor-panel-list__item"
              :class="{'editor-panel-list--active':item.selected}">
              <span>{{ item.name }}</span>
              <span>{{returnStatu(item.pano_status)}}</span>
              <span>{{returnStatu(item.undistort_status)}}</span>
              <el-dropdown :hide-on-click="true" @command="handleCommand">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,1)">生成全景视频</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,7)" >生成去畸变视频</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,2)" >上传全景特效</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,3)" >上传去畸变特效</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,4)" >下载全景视频</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,5)" >下载去畸变视频</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item.video_id,6)" >删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

            </div>
          </div>
        </div>
        <div
              class="ai-button ai-button--primary mng-vr-scene__button"
              style="min-width: 300px; margin-top: 10px"
              @click="clickAddVideo">
          添加新全景视频
        </div>
          <input
          v-show="!!0"
          ref="uploader"
          type="file"
          class="upload__input"
          accept="video/*"
          @change="getVideoFile">
      </div>
    </div>
    <div class="mng-vr-scene">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :scene-id="$route.params.modelId"
               @initialized="onInitialized"
               @toPanoramaId="toGetPanoVideo" />

        <AiDialog class="label-dialog"
                width="441"
                :visible.sync="dialogFormVisible"
                @close="closeDialog">
        <div slot="header" class="label-dialog__header">
          合成全景视频  | 参数调整
        </div>
        <div class="label-dialog__content">
          <div class="label-dialog__seletce">
            <div class ="label-dialog__label"> 使用亮度算法：
            </div>
            <el-select v-model="bright_value" placeholder="请选择">
              <el-option
                v-for="item in bright_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>
          <div class="label-dialog__seletce">
            <div class ="label-dialog__label"> 融合算法：
            </div>
            <el-select v-model="blend_value" placeholder="请选择">
              <el-option
                v-for="item in blend_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>
          <div class="label-dialog__seletce">
            <div class ="label-dialog__label" > 视频类型：
            </div>
            <el-select v-model="video_value" placeholder="请选择">
              <el-option
                v-for="item in video_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </div>

        </div>
        <div slot="footer" class="label-dialog__footer">
          <div class="ai-button ai-button--primary" @click="createVideo">
            确 定
          </div>
          <div class="ai-button" @click="closeDialog">
            取 消
          </div>
        </div>
      </AiDialog>
      <AiDialog class="label-dialog"
                width="441"
                :visible.sync="loadingUIVisible"
                @close="closeloadingDialog">
        <div slot="header" class="label-dialog__header">
          上传进度
        </div>
        <div class="loadingdiv">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="uploadprogress"></el-progress>
        </div>
      </AiDialog>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import VrScene from '@/components/ai-vr-scene.vue';
import SparkMD5 from 'spark-md5';
import axios from 'axios';

export default {
  components: {
    VrScene
  },
  data() {
    return {
      seletVideo_id:null,
      uploadType:0, // 0 全景视频  1 全景特效 2 畸变特效
      uploadprogress:0,
      nowpano_id:'',
      nowselect: null,
      items: [],
      videolist: [],
      status:['未生成','生成中','生成失败','生成成功'],
      pointEditable: false,
      viewEditable: false,
      frameStyle: {
        height: 0,
        width: 0
      },
      canedit: false,
      dialogFormVisible:false,
      loadingUIVisible:false,
      bright_options: [{
          value: true,
          label: '是'
        }, {
          value: false,
          label: '否',
        }],
        bright_value: false,
      blend_options: [{
          value: 'Alpha',
          label: 'Alpha'
        }, {
          value: 'MutilBand',
          label: 'MutilBand',
        }],
        blend_value: '',
       video_options: [{
          value: '1',
          label: '原始视频'
        }, {
          value: '2',
          label: '畸变特效视频',
        }],
        video_value: '',
        videoSrc:''
    };
  },
  mounted() {
    // this.loadPanoramaIcons();
    window.addEventListener('resize', this.updateFrame);
    this.updateFrame();
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener('resize', this.updateFrame);
  },
  methods: {
    onInitialized() {
      console.log('---------------<<<<<<<<<<<-------------------------',this.$refs.vrScene.getCurrentPanoramaId());
      this.nowpano_id = String(this.$refs.vrScene.getCurrentPanoramaId());
    },
    closeDialog() {
      this.dialogFormVisible = false;
    },
    closeloadingDialog(){
      this.loadingUIVisible  =false;
    },
    beforeHandleCommand(data,item){
      return {
        'command': item,
        'data': data
      }
    },
    async handleCommand(item){
      this.$log(item);
      this.seletVideo_id = item.data;
     switch(item.command){
      case 1:{
            this.dialogFormVisible = true;
            this.blend_value='';
            this.video_value='';
            this.bright_value=false;
        }
      break;
      case 4:{
        var  tstatus = 0;

         for(var i=0;i<this.videolist.length;i++)
        {
          if(this.videolist[i].video_id == this.seletVideo_id)
          {
              tstatus = this.videolist[i].pano_status;
          }
        }

        if(tstatus===0||tstatus===undefined)
        {
           this.$message.basic({message: "全景视频不存在"});
        }
        else await this.downLoadPanoVideo();
      }
      break;
      case 7:{
          await this.createUndistort();
        }
      break;
      case 2:{
        this.uploadType = 1;
        this.$refs.uploader.click();
      }
      break;
      case 3:{
        this.uploadType = 2;
        this.$refs.uploader.click();
      }
      break;
      case 5:{
        await this.getUndistort();
      }
      break;
      case 6:{
          //删除
        await this.deleteVideo(item.data);
      }
      break;
     }

    },
    async deleteVideo(id)
    {
      try {
        const { data: { data } } = await this.$http.post(
          '/videoApi/video/delete',
          {
            video_ids: [id]
          }
        );
          console.log('--------deleteVideo---------',data);
          if(data)
          {
            await this.toGetPanoVideo({pID:Number(this.nowpano_id)});
          }
      } catch (error) {
        this.$log(error);
      }
    },
    returnStatu(id)
    {
      // console.log('return;',this.status[id]);
      return this.status[id];
    },
    updateFrame() {
      const scene = this.$refs.vrScene.$el;
      this.frameStyle = {
        height: `${scene.clientHeight - 16}px`,
        width: `${(scene.clientHeight - 16) * 0.5625}px`
      };
    },
    jumpPano() {
      console.log('移动到ID：',this.nowpano_id);
      this.$refs.vrScene.moveToPanoramID(Number(this.nowpano_id));
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '警 告',
        message: '确认要删除该标签吗?'
      }).then(() => {
        this.deleteLabel(id);
      }).catch(() => {});
    },
    async createVideo(){
      if(''==this.blend_value||''==this.video_value)
      {
        this.$message.basic({message: "参数未选全"});
        return;
      }

      this.dialogFormVisible  =false;
      try {
        const { data } = await this.$http.put("/videoApi/video/pano/"+this.seletVideo_id,
        {
            is_light: this.bright_value,
            blend_type: this.blend_value,
            video_type: Number(this.video_value)
        });
        if(data)
        {
          console.log('----createVideo------:',data);
          setTimeout(async ()=>{await this.toGetPanoVideo({pID:Number(this.nowpano_id)});}
          ,3000);


      }
      } catch (error) {
        this.$log(error.error_msg);
      }
        // console.log('blend_value:',this.blend_value,'video_value: ',this.video_value,'bright_value: ',this.bright_value);
    },
    async createUndistort()
    {
      try {
        const { data } = await this.$http.put("/videoApi/video/undistort/"+this.seletVideo_id);
        if(data)
        {
          console.log('----createUndistort------:',data);
          setTimeout(async ()=>{await this.toGetPanoVideo({pID:Number(this.nowpano_id)});}
          ,3000);
        }
        } catch (error) {
          this.$log(error.error_msg);
        }
    },
    async clickAddVideo(){
      // this.loadingUIVisible = true;
      if(this.nowpano_id!='')
      {
        this.uploadType = 0;
        this.$refs.uploader.click();
      }else
      {
        this.$message.basic({message: "没有输入点位ID!"});
      }


    },
    async getUndistort(rerun = 0)
    {

      try {
        const { data } = await this.$http.get("/videoApi/video/undistort/"+this.seletVideo_id);
        if(data)
        {
          // console.log('----getUndistort------:',data.data[0]);
          if(!data.data[0].undistort_status)
          {
              this.$message.basic({message: "去畸变视频不存在"});
          }
          else
          {
            //下载视频
            await this.downloadurl(data.data[0].undistort_url,'mp4',true);
          }
        }
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async getPanoVideo()
    {

    },
    upload(md5,file,filename) {
      console.log('md5')
      console.log(md5)
      console.log(file)
      this.$refs.uploader.value = null;
      console.log(md5)
      this.loadingUIVisible = true;
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            "/videoApiUpload?md5=" + md5,
            file,
            { headers: { "Content-Type": "text/plain" } ,
               onUploadProgress: progressEvent => {
                let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
                this.uploadprogress = (progressEvent.loaded / progressEvent.total * 100 | 0);
                console.log('上传 ' + complete);
              }
            })
          .then(async response => {
           //console.log(response.data.data);
           console.log(response.data.data[0].filename,'this.uploadType: ',this.uploadType);
          switch(this.uploadType)
          {
            case 0:
              //新增全景视频
              await this.addVideo(response.data.data[0].filename,filename);
              break;
            case 1:
              await this.addEffectVideo(response.data.data[0].filename);
              break;
            case 2:
              await this.addUndistortVideo(response.data.data[0].filename);
              break;
          }

           //console.log(response.data.data[0].md5);
            resolve(response.data);
          })
          .catch(error => {
            console.log('错误错误！！！',error);
            reject(error);
          });
      });
    },
    async addVideo(url,filename){
        try {
        const { data } = await this.$http.post("/videoApi/video/create", {
          vr_id: this.$route.params.modelId,
          pano_id: Number(this.nowpano_id),
          name: filename,
          video_file: url
        });
        if(data)
        {
          //刷新数据
          this.loadingUIVisible =false;
          setTimeout(async ()=>{await this.toGetPanoVideo({pID:Number(this.nowpano_id)});}
          ,3000);
        }
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async downLoadPanoVideo()
    {
      try {
          const { data } = await this.$http.get("/videoApi/video/pano/"+this.seletVideo_id);
          if(data)
          {
           console.log(data.data[0].pano_mp4_url);
           await this.downloadurl(data.data[0].pano_mp4_url,'mp4');
           await this.downloadurl(data.data[0].pano_ts_url,'ts');
          }
        } catch (error) {
          this.$log(error.error_msg);
        }
    },
    async downloadurl(url,type,is_undistort = false)
    {
      await axios({
        url: url,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        var name = '全景视频';

        for(var i=0;i<this.videolist.length;i++)
        {
          if(this.videolist[i].video_id == this.seletVideo_id)
          {
              name = this.videolist[i].name;
          }

        }
        if(is_undistort)name+='畸变';
         console.log('this.videolist:',name);
        link.href = url;
        link.setAttribute("download", `${name}.${type}`); //or any other extension
        document.body.appendChild(link);
        link.click();
      });

    },
    async addEffectVideo(url)
    {
      try {
          const { data } = await this.$http.post("/videoApi/video/pano/"+this.seletVideo_id, {
            video_file: url
          });
          if(data)
          {
            this.loadingUIVisible =false;
            //刷新数据
          setTimeout(async ()=>{await this.toGetPanoVideo({pID:Number(this.nowpano_id)});}
          ,3000);
          }
        } catch (error) {
          this.$log(error.error_msg);
        }
    },
    async addUndistortVideo(url)
    {
      try {
          const { data } = await this.$http.post("/videoApi/video/undistort/"+this.seletVideo_id, {
            video_file: url
          });

          console.log(data);
          if(data)
          {
            this.loadingUIVisible =false;
            //刷新数据
          setTimeout(async ()=>{await this.toGetPanoVideo({pID:Number(this.nowpano_id)});}
          ,3000);
          }
        } catch (error) {
          this.$log(error.error_msg);
        }
    },
    getVideoFile() {
         var file = this.$refs.uploader.files[0];
        const fileSize = file.size; // 文件大小
        const chunkSize = 1024 * 1024 * 10; // 切片的大小
        const chunks = Math.ceil(fileSize / chunkSize); // 获取切片个数
        const fileReader = new FileReader();
        const spark = new SparkMD5.ArrayBuffer();
        const bolbSlice =
            File.prototype.slice ||
            File.prototype.mozSlice ||
            File.prototype.webkitSlice;
        let currentChunk = 0;

        fileReader.onload = e => {
            const res = e.target.result;

            spark.append(res);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
                console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk +1}分片解析`);
            } else {
                const md5 = spark.end();
                console.log('解析完成');
                this.upload(md5,file,file.name.split('.')[0]);
            }
        };

        const loadNext = () => {
            const start = currentChunk * chunkSize;
            const end =
                start + chunkSize > file.size ? file.size : start + chunkSize;
            fileReader.readAsArrayBuffer(bolbSlice.call(file, start, end));
        };
        loadNext();
    },
    async saveRoam(){
      try {
          const data = await this.$http.post(
            '/animation/save',
            {
              store_id: this.$route.params.modelId,
              data: this.roamlist
            }
          );
          this.$message.basic({
            message: '保存list成功'
          });
        } catch (error) {
          this.$log(error);
        }
    },
    async toGetPanoVideo(data){
      console.log('获取 PID 的VIDEO 数据：',data.pID);
      // this.nowpano_id = data.pID;
      //     this.videolist =  [
      //             {
      //                 "video_id": "Z4yZZl3knh",
      //                 "name": "全景视频1",
      //                 "undistort_url": "https://robot-vr-public.cdn.bcebos.com/pano_videos/e9e736/e9e73691765dc2c3db9ab181aa50fec1.mp4",
      //                 "undistort_status": 3,
      //                 "pano_mp4_url": "",
      //                 "pano_ts_url": "",
      //                 "pano_status": 0,
      //                 "pano_id": 53238
      //             },
      //             {
      //                 "video_id": "Aj3rPqXFkm",
      //                 "name": "全景视频2",
      //                 "undistort_url": "",
      //                 "undistort_status": 0,
      //                 "pano_mp4_url": "https://robot-vr-public.cdn.bcebos.com/pano_videos/e9e736/e9e73691765dc2c3db9ab181aa50fec1.mp4",
      //                 "pano_ts_url": "https://robot-vr-public.cdn.bcebos.com/pano_videos/e9e736/e9e73691765dc2c3db9ab181aa50fec1.ts",
      //                 "pano_status": 3,
      //                 "pano_id": 53238
      //             }
      //         ];


      // return;
      if(Number(data.pID))
      {
        // console.log('--------------------------');
        this.nowpano_id = data.pID;
      }

       try {
        //  this.nowpano_id = data.pID;

        const { data: { data } } = await this.$http.post(
          '/videoApi/video/list',
          {
            vr_id: this.$route.params.modelId,
            pano_id: Number(this.nowpano_id)
          });
          this.videolist = data;
          this.$log(data);
        } catch (error) {
          this.$log(error);
        }

    }

  }
};
</script>

<style lang="scss" scoped>
.switch-item {
  display: flex;
  align-items: center;

  span {
    margin-left: 7px;
    font-size: 12px;
    color: #666;
  }
}

.frame-support {
  top: 80px;
  left: 85px;
  width: calc(100% - 170px);
  height: calc(100% - 210px);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;

  &__frame {
    border: 2px dashed #fff;
    position: relative;
  }

  &__corner {
    width: 50px;
    height: 50px;
    position: absolute;

    &--topleft {
      top: -4px;
      left: -4px;
      border-top: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--topright {
      top: -4px;
      right: -4px;
      border-top: 6px solid #fff;
      border-right: 6px solid #fff;
    }

    &--bottomleft {
      bottom: -4px;
      left: -4px;
      border-bottom: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--bottomright {
      bottom: -4px;
      right: -4px;
      border-bottom: 6px solid #fff;
      border-right: 6px solid #fff;
    }
  }
}

.editor-panel-labelbutton {
  margin-left: 220px;
  font-size: 12px;
}

.bottom_actions{
  width: calc(100% - 170px);
  display: grid;
  grid-template-columns: 15% 15% 40% 15% 15%;
  align-items: center;
  justify-content: center;
}

.editor-panel-list {
  height: 500px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;

  &__title {
    display: grid;
    background-color: #e5e5e5;
    grid-template-columns: 30% 25% 25% 20%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    color: #666;
    user-select: none;
  }

  &__items {
    overflow-y: scroll;
    flex: 1;
  }

  &--active {
    background-color: rgb(85, 107, 233);

    span {
      color: rgb(255, 255, 255);
    }
  }

  &__item {
    display: grid;
    grid-template-columns: 30% 25% 25% 20%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;

    &:last-child {
      border-bottom: 0;
    }
  }

  &__actions .ai-button {
    margin: 0 0px;
  }
}

.loadingdiv {
  width: 80%;

  margin-left: 35px;
  margin-top: 40px;
}

.label-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__content {
    display: block;
    padding: 20px 16px;
  }

  &__seletce {
    display: flex;
    padding: 5px 5px;
  }

  &__label {
    width: 30%;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.upload__input {
  visibility: hidden;
}
</style>
